import type { Tone } from "./types";

export type FreshnessPresentation = {
  label: string;
  tone: Tone;
  detail: string;
};

export function formatLastVerified(value?: string | null) {
  if (!value) return "last verified time unavailable";
  const date = new Date(value);
  if (Number.isNaN(date.valueOf())) return `last verified ${value}`;
  const formatted = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC"
  }).format(date).toUpperCase();
  return `last verified ${formatted} UTC`;
}

export function freshnessPresentation(status: string, online: boolean, collectedAt?: string | null): FreshnessPresentation {
  const detail = formatLastVerified(collectedAt);
  if (!online) return { label: "OFFLINE", tone: "warning", detail };

  const normalized = status.toLowerCase();
  if (["live", "success", "succeeded"].includes(normalized)) return { label: "LIVE", tone: "positive", detail };
  if (["candidate", "delayed", "stale"].includes(normalized)) {
    return { label: normalized.toUpperCase(), tone: "warning", detail };
  }
  if (["error", "failed", "blocked", "quarantined"].includes(normalized)) {
    return { label: normalized.toUpperCase(), tone: "danger", detail };
  }
  return { label: normalized.toUpperCase(), tone: "neutral", detail };
}
